import * as React from 'react';
import classnames from 'classnames';

import Checkbox from 'components/checkbox';
import { FR_INVITE_STATUS, FR_INVITE_STATUS_TO_TEXT_MAP, IFRFriend } from '../fr-friend-list-common';
import { buildUserImageSrc } from 'utils/user-avatar';
import { translate } from 'components/translate-hoc';
import { ITranslationProps } from 'types/translation';
import './fr-friend-list-item.styles.less';
import { getModeClass } from 'utils/css';

export class FRFriendListItem extends React.Component<IFRFriendListItemProps> {
    public render(): JSX.Element {
        const {
            env,
            friend,
            dangerouslyTranslateWithHTML: translateKey,
            style: containerStyle,
            shouldInheritStyles,
            onCheck
        } = this.props;
        
        const avatarStyle: React.CSSProperties = { backgroundImage: `url(${buildUserImageSrc(env, friend.ubiId)})` };
        const isAvailable =  this.props.friend.status === FR_INVITE_STATUS.AVAILABLE;

        const status: string = translateKey(FR_INVITE_STATUS_TO_TEXT_MAP[friend.status]);
        const basePageStyleClass = getModeClass('sitegen-fr-friend-list-item', shouldInheritStyles);

        return (
            <div 
                className={classnames(basePageStyleClass, {
                    'sitegen-fr-friend-list-item--disabled': !isAvailable,
                    'sitegen-fr-friend-list-item-embedded--disabled': !isAvailable,
                })} 
                style={containerStyle}
            >            
                <div className={`${basePageStyleClass}__inner`}>
                    <div className={`${basePageStyleClass}__avatar`} style={avatarStyle} />
                    <div className={`${basePageStyleClass}__user-info`}>
                        <div className={`${basePageStyleClass}__user-info-name`}>{friend.name}</div>
                        <div className={`${basePageStyleClass}__user-info-status`}>{status}</div>
                    </div>
                    <Checkbox
                        shouldInheritStyles={shouldInheritStyles}
                        checked={this.props.checked}
                        onChange={() => isAvailable && onCheck(friend.ubiId)} />
                </div>
            </div>
        );
    }
}

export const FRFriendListItemWithTranslations = translate()(FRFriendListItem);

export interface IFRFriendListItemProps extends ITranslationProps {
    readonly env: string;
    readonly friend: IFRFriend;
    readonly checked?: boolean;
    readonly style?: React.CSSProperties;
    readonly onCheck: (ubiId: string) => void;
    readonly shouldInheritStyles: boolean;
}
